export default function getTitle(email, users) {
    if (!users) return "";
    const user = users.find((user) => user.id === email);
    if (user) {
        return user.title;
    } else {
        return "";
    }
}
